import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { NavigationState } from '../../enums/navigation-state.enum';
import { AuthService } from '../../services/auth.service';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { TopicService } from 'src/app/features/user/components/topic/services/topic.service';
import { interval, Subscription } from 'rxjs';

@Component({
  selector: 'app-nav-bar',
  templateUrl: './nav-bar.component.html',
  styleUrls: ['./nav-bar.component.scss']
})
export class NavBarComponent implements OnInit, OnDestroy {
  @Input() user!: string;
  @Input() clientName?: string;
  @Input() state!: NavigationState;
  isMenuOpen = false;
  unreadMessagesCount = 0;
  private messageCheckInterval: Subscription | null = null;

  constructor(
    private authService: AuthService,
    private router: Router,
    private topicService: TopicService
  ) { }

  ngOnInit() {

    // Check for messages immediately if logged in
    if (this.authService.isLoggedIn()) {
      this.updateUnreadMessagesCount();
    }

    // Subscribe to login state changes
    this.authService.getCurrentUser().subscribe(user => {
      if (user) {
        // User is logged in, check messages immediately
        this.updateUnreadMessagesCount();

        // Start interval for checking messages every 10 minutes
        if (!this.messageCheckInterval) {
          this.messageCheckInterval = interval(10 * 60 * 1000).subscribe(() => {
            this.updateUnreadMessagesCount();
          });
        }
      } else {
        // User is logged out, clear interval if it exists
        if (this.messageCheckInterval) {
          this.messageCheckInterval.unsubscribe();
          this.messageCheckInterval = null;
        }
        this.unreadMessagesCount = 0;
      }
    });
  }

  ngOnDestroy() {
    if (this.messageCheckInterval) {
      this.messageCheckInterval.unsubscribe();
    }
  }

  logout() {
    this.authService.logout().subscribe((res) => {
      if (!res.success) {
        this.router.navigate(['/home']);
      }
    });
  }

  isLoggedIn() {
    return this.state === NavigationState.loggedIn;
  }

  isLogIn() {
    return this.state === NavigationState.logIn;
  }

  isSignUp() {
    return this.state === NavigationState.signUp;
  }

  toggleMenu() {
    this.isMenuOpen = !this.isMenuOpen;
  }

  closeMenu() {
    this.isMenuOpen = false;
  }

  private updateUnreadMessagesCount() {
    if (!this.authService.isLoggedIn()) return;
    this.topicService.checkNewMessages().subscribe({
      next: (result) => {
        // Get current user email first
        this.authService.getCurrentUser().subscribe(user => {
          if (!user) return;

          // Sum all unread messages across topics
          this.unreadMessagesCount = Object.values(result)
            .map((messages: any[]) => messages.filter((msg: any) =>
              !msg.readBy || !msg.readBy.includes(user.id)
            ).length)
            .reduce((sum: number, count: number) => sum + count, 0);
        });
      },
      error: () => {
        this.unreadMessagesCount = 0;
      }
    });
  }
}
